module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/podcast_art@1x.455481e.jpg";